import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Dropdown, Menu, Modal, Button, Tooltip, Row, Col, Card, Statistic, Badge, Input, Popover, Divider, Tag, Checkbox } from 'antd';
import FileDownload from 'js-file-download';
import moment from 'moment';
import 'moment/locale/pt-br';
import DownloadBatch from '../Components/DownloadBatch';

import { toBRL } from '../UI/InputCurrency';
import ExtrasTableList from './Components/TableList';
import * as billsToReceiveActions from '~/components/BillsToReceive/actions';
import {
  DropdownButton,
} from './styles';
import { request } from '../Instance';
import { ModuleHeader, ModuleHeaderWrapper } from '../ModuleHeader';
import DateNavigation from '~/_shared/components/DateNavigation';
import PulseBadge from '~/components/PulseBadge';
import SelectionToolbar from '~/_shared/components/SelectionToolbar';
import StatTooltip from '~/_shared/components/StatTooltip';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import {
  getMonthPeriod,
  getExtrasRequest,
  isExtrasPeriodDefault,
  getExtrasPeriodLabel,
  countActiveExtrasFilters,
} from './filters';

var fmtBRL = function(v) { return toBRL(v != null ? v : 0); };

var STATUS_LABELS = {
  paid: 'Pago', pendent: 'Pendente', defaulting: 'Inadimplente',
  processed: 'Ajuizado', revised: 'Revisado', unrevised: 'Não Revisado'
};

var ORIGIN_LABELS = {
  abertura: 'Abertura', alteracao: 'Alteração', encerramento: 'Encerramento',
  tarefa: 'Tarefa', troca_entrada: 'Troca (entrada)', troca_saida: 'Troca (saída)',
  outros: 'Outros', certificate: 'Certificado', manual: 'Manual'
};

class CustomersList extends Component {
  // Filters (period, view, status, origin, search) live in the screen
  // (usePersistedFilters, passed as `persisted`), which reloads the list when
  // the period changes. Only UI state stays here.
  state = {
    selectedRowKeys: [],
    // A restored view must not be overridden by the "unreviewed first" switch.
    _initialCheckDone: !!(this.props.persisted && this.props.persisted.wasRestored),
  }

  getFilters = () => this.props.persisted.filters;

  setFilters = (partial) => {
    this.props.persisted.setFilters(partial);
  }

  componentDidUpdate(prevProps) {
    if (!this.state._initialCheckDone && this.props.extras && this.props.extras.length > 0) {
      var hasUnreviewed = this.props.extras.some(function(item) { return item.extra && !item.extra.revised; });
      if (hasUnreviewed && this.getFilters().extraStatus === 'revised') {
        this.setFilters({ extraStatus: 'not_revised' });
      }
      this.setState({ _initialCheckDone: true });
    }
  }

  handleMonthChange = (newDate) => {
    this.setFilters(getMonthPeriod(newDate));
  }

  handleRangeChange = (newFrom, newTo) => {
    this.setFilters({ from: newFrom, to: newTo });
  }

  handleClearFilters = () => {
    this.props.persisted.resetFilters();
  }

  onAction = (e, bill) => {
    switch(e.key){
      case 'edit':
        this.props.openBillForm(bill.extra);
      break;
      case 'paid':
        Modal.confirm({
          title: 'Você realmente deseja alterar este pagamento para pago?',
          content: 'Esta ação não poderá ser desfeita.',
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: () => this.props.setPaid(bill.id).then(response => this.props.loadExtras(this.props.filter))
        });
      break;
      case 'inadimplente':
        Modal.confirm({
          title: 'Você realmente deseja marcar como inadimplente?',
          content: 'Você poderá alterar isso mais tarde.',
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: () => this.props.changeStatus(bill.id, 'Inadimplente').then(response => this.props.loadExtras(this.props.filter))
        });
      break;
      case 'ajuizado':
        Modal.confirm({
          title: 'Você realmente deseja marcar como ajuizado?',
          content: 'Você poderá alterar isso mais tarde.',
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: () => this.props.changeStatus(bill.id, 'Ajuizado').then(response => this.props.loadExtras(this.props.filter))
        });
      break;
    }
  }

  getFilename = (data) => {
    const now = moment(data.apuration_at).format('MM-YYYY');
    return data.customer.name + '_SERVICO_EXTRA_' + now + '.pdf';
  }

  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  exportToExcel = () => {
    var filterData = this.state.selectedRowKeys.length > 0
      ? { ids: this.state.selectedRowKeys }
      : {
          filters: getExtrasRequest(this.getFilters())
      };

    request(
      "POST",
      "extras/payments/export/excel",
      filterData,
      true,
      { responseType: 'blob' }
    )
    .then(function(response) {
        var now = moment().format('YYYY-MM-DD_hh-mm-ss');
        FileDownload(response.data, 'Servicos_extras_' + now + '.xlsx');
    });
  }

  handleBulkPrint = () => {
    var ids = this.state.selectedRowKeys;
    request(
      "POST",
      "extras/payments/print/batch",
      { ids: ids },
      true,
      { responseType: ids.length <= 10 ? 'blob' : 'json' }
    )
    .then(function(response) {
      if (ids.length <= 10) {
        FileDownload(response.data, 'servicos_extras.zip');
      } else {
        Modal.success({ title: 'Arquivo em processamento', content: 'O arquivo será enviado por e-mail quando estiver pronto.' });
      }
    });
  }

  getRestoredSummary = (applied, defaults) => {
    var parts = [];
    if (!isExtrasPeriodDefault(applied, defaults)) parts.push(getExtrasPeriodLabel(applied));
    if (applied.extraStatus !== defaults.extraStatus) parts.push('Não revisados');
    applied.statusFilters.forEach(function(s) { parts.push(s); });
    applied.originFilters.forEach(function(o) { parts.push(ORIGIN_LABELS[o] || o); });
    if (applied.search) parts.push('Busca: ' + applied.search);
    return parts.join(' · ');
  }

  handleClearSelection = () => {
    this.setState({ selectedRowKeys: [] });
  }

  computeStats = (activeExtras) => {
    var totalAmount = 0;
    var totalPaid = 0;
    var inadAmount = 0;
    var inadCount = 0;
    var inadPaid = 0;
    var ajuAmount = 0;
    var ajuCount = 0;
    var ajuPaid = 0;
    var paidCount = 0;
    var pendingCount = 0;
    var totalCount = activeExtras.length;

    for (var i = 0; i < totalCount; i++) {
      var item = activeExtras[i];
      var amount = parseFloat(item.amount) || 0;
      totalAmount += amount;
      if (item.status === 'Pago') {
        totalPaid += amount;
        paidCount++;
      }
      if (item.status === 'Pendente') pendingCount++;
      if (item.status === 'Inadimplente') {
        inadAmount += amount;
        inadCount++;
        if (item.paid_at) inadPaid += amount;
      }
      if (item.status === 'Ajuizado') {
        ajuAmount += amount;
        ajuCount++;
        if (item.paid_at) ajuPaid += amount;
      }
    }

    return {
      totalCount: totalCount,
      totalAmount: totalAmount,
      totalPaid: totalPaid,
      totalSaldo: totalAmount - totalPaid,
      paidCount: paidCount,
      pendingCount: pendingCount,
      paidPercent: totalAmount > 0 ? Math.round((totalPaid / totalAmount) * 100) : 0,
      inadAmount: inadAmount,
      inadCount: inadCount,
      inadPaid: inadPaid,
      inadBalance: inadAmount - inadPaid,
      ajuAmount: ajuAmount,
      ajuCount: ajuCount,
      ajuPaid: ajuPaid,
      ajuBalance: ajuAmount - ajuPaid,
    };
  }

  render() {
    var extras = this.props.extras;
    var user = this.props.user;
    var isLoading = this.props.isLoading;
    var persisted = this.props.persisted;
    var applied = persisted.filters;
    var defaults = persisted.defaults;
    var search = applied.search || '';
    var selectedRowKeys = this.state.selectedRowKeys;
    var isPeriodDefault = isExtrasPeriodDefault(applied, defaults);

    var filtered = (extras !== null) ? extras.filter(function(str) {
      if (str.customer.name.toLowerCase().indexOf(search.toLowerCase()) >= 0) return true;
      if (str.customer.cod !== null && str.customer.cod.toLowerCase().indexOf(search.toLowerCase()) >= 0) return true;
      return false;
    }) : [];

    var revisedExtras = filtered.filter(function(item) { return item.extra.revised; });
    var notRevisedExtras = filtered.filter(function(item) { return !item.extra.revised; });
    var activeExtras = applied.extraStatus === 'revised' ? revisedExtras : notRevisedExtras;

    var stats = this.computeStats(activeExtras);

    // Compute counts for filter pills
    var statusCounts = { Pago: 0, Pendente: 0, Inadimplente: 0, Ajuizado: 0 };
    var originCategoryMap = { 1: 'abertura', 2: 'alteracao', 3: 'encerramento', 4: 'tarefa', 5: 'troca_entrada', 6: 'outros', 7: 'troca_saida' };
    var originCounts = { abertura: 0, alteracao: 0, encerramento: 0, tarefa: 0, certificate: 0, troca_entrada: 0, troca_saida: 0, outros: 0, manual: 0 };
    for (var ci = 0; ci < activeExtras.length; ci++) {
      var ce = activeExtras[ci];
      if (statusCounts[ce.status] !== undefined) statusCounts[ce.status]++;
      if (ce.extra && ce.extra.certificate_id) {
        originCounts.certificate++;
      } else if (ce.extra && ce.extra.dash_task_id) {
        var ccat = ce.extra.dashtask && ce.extra.dashtask.category ? parseInt(ce.extra.dashtask.category) : 0;
        var okey = originCategoryMap[ccat];
        if (okey && originCounts[okey] !== undefined) originCounts[okey]++;
      } else {
        originCounts.manual++;
      }
    }

    var totalTooltip = (
      <StatTooltip
        title="Resumo do Total"
        rows={[
          { label: 'Parcelas', value: stats.totalCount + ' registros' },
          { label: 'Pagos', value: stats.paidCount + '' },
          { label: 'Pendentes', value: stats.pendingCount + '', color: '#ffc53d' },
          { label: 'Total', value: fmtBRL(stats.totalAmount), bold: true, borderTop: true },
        ]}
      />
    );

    var pagoTooltip = (
      <StatTooltip
        title="Detalhes de Pagamento"
        rows={[
          { label: 'Pagos', value: stats.paidCount + ' de ' + stats.totalCount },
          { label: 'Sem pagamento', value: (stats.totalCount - stats.paidCount) + '', color: '#ff7875' },
          { label: '% Recebido', value: stats.paidPercent + '%', bold: true, borderTop: true, color: stats.paidPercent >= 80 ? '#95de64' : stats.paidPercent >= 50 ? '#ffc53d' : '#ff7875' },
          { label: 'Total pago', value: fmtBRL(stats.totalPaid), bold: true },
        ]}
      />
    );

    var saldoTooltip = (
      <StatTooltip
        title="Detalhes do Saldo"
        rows={[
          { label: 'Total a receber', value: fmtBRL(stats.totalAmount) },
          { label: 'Total recebido', value: fmtBRL(stats.totalPaid), color: '#95de64' },
          { label: 'Saldo pendente', value: fmtBRL(stats.totalSaldo), bold: true, borderTop: true, color: '#ff7875' },
        ]}
      />
    );

    var inadAjuTooltip = (
      <StatTooltip
        title="Inadimplentes & Ajuizados"
        rows={[
          { label: 'Inadimplentes', value: stats.inadCount + ' parcela(s)', color: '#ffc53d' },
          { label: '  Valor total', value: fmtBRL(stats.inadAmount) },
          { label: '  Valor pago', value: fmtBRL(stats.inadPaid), color: '#95de64' },
          { label: '  Saldo', value: fmtBRL(stats.inadBalance), bold: true, color: '#ff7875' },
          { label: 'Ajuizados', value: stats.ajuCount + ' parcela(s)', borderTop: true, color: '#d9d9d9' },
          { label: '  Valor total', value: fmtBRL(stats.ajuAmount) },
          { label: '  Valor pago', value: fmtBRL(stats.ajuPaid), color: '#95de64' },
          { label: '  Saldo', value: fmtBRL(stats.ajuBalance), bold: true, color: '#ff7875' },
        ]}
      />
    );

    return (
      <div>
        <ModuleHeaderWrapper>
          <ModuleHeader
            breadcrumbs={['Financeiro', 'Serviços extras']}
            title="Serviços Extras"
            search={
              <Input
                prefix={<Icon type="search" style={{ color: '#bfbfbf' }} />}
                value={search}
                placeholder="Pesquisar"
                allowClear
                onChange={function(e) { this.setFilters({ search: e.target.value }); }.bind(this)}
                style={{ width: 240, borderRadius: 8 }}
              />
            }
            center={
              <>
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  content={
                    <div style={{ width: 560 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                        <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                          {!persisted.isDefault && (
                            <a
                              style={{ fontSize: 12, color: '#f5222d' }}
                              onClick={this.handleClearFilters}
                            >
                              Limpar tudo
                            </a>
                          )}
                          <DateNavigation
                            date={moment(applied.from, "YYYY-MM-DD").format("YYYY-MM")}
                            onChange={this.handleMonthChange}
                            format="YYYY-MM"
                            rangeFrom={applied.from}
                            rangeTo={applied.to}
                            onRangeChange={this.handleRangeChange}
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 20 }}>
                        {/* Column 1: Visualização */}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Visualização</div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {[
                              { value: 'revised', label: 'Revisados', count: revisedExtras.length, color: '#52c41a' },
                              { value: 'not_revised', label: 'Não revisados', count: notRevisedExtras.length, color: '#f5222d' },
                            ].map(function(opt) {
                              var isActive = applied.extraStatus === opt.value;
                              return (
                                <div
                                  key={opt.value}
                                  onClick={function() { this.setFilters({ extraStatus: opt.value }); }.bind(this)}
                                  style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                                    border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                                    background: isActive ? opt.color + '0a' : '#fafafa',
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <span style={{ fontSize: 12, color: isActive ? '#262626' : '#8c8c8c' }}>{opt.label}</span>
                                  <span style={{ fontSize: 13, fontWeight: 600, color: isActive ? opt.color : '#bfbfbf' }}>{opt.count}</span>
                                </div>
                              );
                            }.bind(this))}
                          </div>
                        </div>
                        {/* Column 2: Status */}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</div>
                          <Checkbox.Group
                            value={applied.statusFilters}
                            onChange={function(vals) { this.setFilters({ statusFilters: vals }); }.bind(this)}
                          >
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                              {[
                                { value: 'Pago', color: '#52c41a' },
                                { value: 'Pendente', color: '#faad14' },
                                { value: 'Inadimplente', color: '#f5222d' },
                                { value: 'Ajuizado', color: '#8c8c8c' },
                              ].map(function(s) {
                                var isActive = applied.statusFilters.indexOf(s.value) !== -1;
                                var cnt = statusCounts[s.value] || 0;
                                return (
                                  <label
                                    key={s.value}
                                    style={{
                                      display: 'inline-flex', alignItems: 'center', gap: 6,
                                      padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                                      background: isActive ? s.color : '#f5f5f5',
                                      color: isActive ? '#fff' : '#595959',
                                      border: '1px solid ' + (isActive ? s.color : '#e8e8e8'),
                                      transition: 'all 0.2s',
                                      opacity: cnt === 0 && !isActive ? 0.5 : 1,
                                    }}
                                  >
                                    <Checkbox value={s.value} style={{ display: 'none' }} />
                                    {!isActive && <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.color, flexShrink: 0 }} />}
                                    {isActive && <Icon type="check" style={{ fontSize: 11 }} />}
                                    {s.value}
                                    <span style={{ fontSize: 11, opacity: 0.8 }}>({cnt})</span>
                                  </label>
                                );
                              }.bind(this))}
                            </div>
                          </Checkbox.Group>
                        </div>
                        {/* Column 3: Origem */}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Origem</div>
                          <Checkbox.Group
                            value={applied.originFilters}
                            onChange={function(vals) { this.setFilters({ originFilters: vals }); }.bind(this)}
                          >
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                              {[
                                { value: 'abertura', label: 'Abertura', color: '#52c41a' },
                                { value: 'alteracao', label: 'Alteração', color: '#faad14' },
                                { value: 'encerramento', label: 'Encerramento', color: '#f5222d' },
                                { value: 'tarefa', label: 'Tarefa', color: '#722ed1' },
                                { value: 'certificate', label: 'Certificado', color: '#1890ff' },
                                { value: 'troca_entrada', label: 'Troca (entrada)', color: '#13c2c2' },
                                { value: 'troca_saida', label: 'Troca (saída)', color: '#eb2f96' },
                                { value: 'outros', label: 'Outros', color: '#8c8c8c' },
                                { value: 'manual', label: 'Manual', color: '#bfbfbf' },
                              ].map(function(o) {
                                var isActive = applied.originFilters.indexOf(o.value) !== -1;
                                var cnt = originCounts[o.value] || 0;
                                return (
                                  <label
                                    key={o.value}
                                    style={{
                                      display: 'inline-flex', alignItems: 'center', gap: 6,
                                      padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                                      background: isActive ? o.color : '#f5f5f5',
                                      color: isActive ? '#fff' : '#595959',
                                      border: '1px solid ' + (isActive ? o.color : '#e8e8e8'),
                                      transition: 'all 0.2s',
                                      opacity: cnt === 0 && !isActive ? 0.5 : 1,
                                    }}
                                  >
                                    <Checkbox value={o.value} style={{ display: 'none' }} />
                                    {!isActive && <span style={{ width: 8, height: 8, borderRadius: '50%', background: o.color, flexShrink: 0 }} />}
                                    {isActive && <Icon type="check" style={{ fontSize: 11 }} />}
                                    {o.label}
                                    <span style={{ fontSize: 11, opacity: 0.8 }}>({cnt})</span>
                                  </label>
                                );
                              }.bind(this))}
                            </div>
                          </Checkbox.Group>
                        </div>
                      </div>
                    </div>
                  }
                >
                  <Badge
                    count={countActiveExtrasFilters(applied, defaults)}
                    offset={[-4, 0]}
                    style={{ backgroundColor: '#722ed1' }}
                  >
                    <Button
                      icon="bars"
                      style={{ borderRadius: 8 }}
                    >
                      Filtros
                    </Button>
                  </Badge>
                </Popover>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="new" onClick={function() { this.props.openBillForm({}); }.bind(this)}>
                        <Icon type="plus" /> Cadastrar Conta
                      </Menu.Item>
                      <Menu.Divider />
                      {selectedRowKeys.length > 0 && (
                        <Menu.Item key="pdf">
                          <DownloadBatch
                            url="/extras/payments/print/batch"
                            filename="servico-extra.zip"
                            ids={selectedRowKeys}
                          >
                            <DropdownButton><Icon type="file-pdf" /> Exportar PDF</DropdownButton>
                          </DownloadBatch>
                        </Menu.Item>
                      )}
                      <Menu.Item key="csv" onClick={this.exportToExcel}>
                        <Icon type="file-excel" /> Exportar Excel
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <Button
                    icon="plus"
                    shape="circle"
                  />
                </Dropdown>
              </>
            }
            actions={null}
            advanced={
              (function() {
                var STATUS_COLORS = { Pago: '#52c41a', Pendente: '#faad14', Inadimplente: '#f5222d', Ajuizado: '#8c8c8c' };
                var ORIGIN_COLORS = { abertura: '#52c41a', alteracao: '#faad14', encerramento: '#f5222d', tarefa: '#722ed1', certificate: '#1890ff', troca_entrada: '#13c2c2', troca_saida: '#eb2f96', outros: '#8c8c8c', manual: '#bfbfbf' };
                // Pills show the applied values; removing one resets only that filter.
                var pills = [{
                  key: 'month', label: getExtrasPeriodLabel(applied),
                  color: isPeriodDefault ? '#1890ff' : '#722ed1', icon: 'calendar',
                  onRemove: isPeriodDefault ? undefined : function() { this.setFilters({ from: defaults.from, to: defaults.to }); }.bind(this),
                }];

                if (applied.extraStatus !== defaults.extraStatus) {
                  pills.push({
                    key: 'viz', label: 'Não revisados', color: '#f5222d',
                    onRemove: function() { this.setFilters({ extraStatus: defaults.extraStatus }); }.bind(this),
                  });
                }

                applied.statusFilters.forEach(function(s) {
                  pills.push({
                    key: 'status-' + s, label: s, color: STATUS_COLORS[s] || '#1890ff',
                    onRemove: function() { this.setFilters({ statusFilters: applied.statusFilters.filter(function(v) { return v !== s; }) }); }.bind(this),
                  });
                }.bind(this));

                applied.originFilters.forEach(function(o) {
                  pills.push({
                    key: 'origin-' + o, label: ORIGIN_LABELS[o] || o, color: ORIGIN_COLORS[o] || '#595959',
                    onRemove: function() { this.setFilters({ originFilters: applied.originFilters.filter(function(v) { return v !== o; }) }); }.bind(this),
                  });
                }.bind(this));

                if (search) {
                  pills.push({
                    key: 'search', label: search, color: '#722ed1', icon: 'search',
                    onRemove: function() { this.setFilters({ search: '' }); }.bind(this),
                  });
                }

                return React.createElement(FilterPillsBar, {
                  pills: pills,
                  onClearAll: persisted.isDefault ? undefined : this.handleClearFilters,
                });
              }.bind(this))()
            }
          />
        </ModuleHeaderWrapper>

        <RestoredFiltersNotice
          visible={persisted.wasRestored}
          summary={this.getRestoredSummary(applied, defaults)}
          onReset={this.handleClearFilters}
          onDismiss={persisted.dismissRestored}
        />

        <Row gutter={16} style={{ paddingTop: 10 }}>
          <Col span={4}>
            <Tooltip title={totalTooltip} placement="bottom">
              <Card style={{ marginBottom: '10px' }} bodyStyle={{ padding: '15px' }}>
                <Statistic
                  title={<span><Icon type="wallet" style={{ marginRight: 6, color: '#1890ff' }} />Total</span>}
                  value={stats.totalAmount}
                  precision={2}
                  formatter={toBRL}
                />
              </Card>
            </Tooltip>
          </Col>
          <Col span={4}>
            <Tooltip title={pagoTooltip} placement="bottom">
              <Card style={{ marginBottom: '10px' }} bodyStyle={{ padding: '15px' }}>
                <Statistic
                  title={<span><Icon type="check-circle" style={{ marginRight: 6, color: '#52c41a' }} />Pago</span>}
                  value={stats.totalPaid}
                  precision={2}
                  valueStyle={{ color: '#52c41a' }}
                  formatter={toBRL}
                />
              </Card>
            </Tooltip>
          </Col>
          <Col span={4}>
            <Tooltip title={saldoTooltip} placement="bottom">
              <Card style={{ marginBottom: '10px' }} bodyStyle={{ padding: '15px' }}>
                <Statistic
                  title={<span><Icon type="clock-circle" style={{ marginRight: 6, color: '#f5222d' }} />Saldo</span>}
                  value={stats.totalSaldo}
                  precision={2}
                  valueStyle={{ color: '#f5222d' }}
                  formatter={toBRL}
                />
              </Card>
            </Tooltip>
          </Col>
          <Col span={8}>
            <Tooltip title={inadAjuTooltip} placement="bottom">
              <Card style={{ marginBottom: '10px' }} bodyStyle={{ padding: '15px' }}>
                <Row>
                  <Col span={12}>
                    <Statistic
                      title={<span><Icon type="warning" style={{ marginRight: 6, color: '#faad14' }} />Inadimplentes</span>}
                      value={stats.inadBalance}
                      precision={2}
                      formatter={toBRL}
                      valueRender={function(val) { return <small>{val}</small>; }}
                    />
                  </Col>
                  <Col span={12}>
                    <Statistic
                      title={<span><Icon type="audit" style={{ marginRight: 6, color: '#8c8c8c' }} />Ajuizados</span>}
                      value={stats.ajuBalance}
                      precision={2}
                      formatter={toBRL}
                      valueRender={function(val) { return <small>{val}</small>; }}
                    />
                  </Col>
                </Row>
              </Card>
            </Tooltip>
          </Col>
          <style dangerouslySetInnerHTML={{ __html: '@keyframes pulseGlow { 0% { box-shadow: 0 0 0 0 rgba(245,34,45,0.4); } 70% { box-shadow: 0 0 0 6px rgba(245,34,45,0); } 100% { box-shadow: 0 0 0 0 rgba(245,34,45,0); } }' }} />
          <Col span={4}>
            <Card
              onClick={function() { this.setFilters({ extraStatus: applied.extraStatus === 'not_revised' ? 'revised' : 'not_revised' }); }.bind(this)}
              style={{
                marginBottom: '10px',
                border: '1px solid #e8e8e8',
                boxShadow: notRevisedExtras.length > 0 ? '0 2px 8px rgba(245, 34, 45, 0.15)' : 'none',
              }}
              bodyStyle={{
                padding: '15px',
                cursor: 'pointer',
                background: notRevisedExtras.length > 0 ? 'linear-gradient(135deg, #fff1f0 0%, #fff 100%)' : 'white',
              }}
            >
              <Statistic
                title={
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      width: 18, height: 18, borderRadius: '50%', flexShrink: 0,
                      background: notRevisedExtras.length > 0 ? '#f5222d' : '#d9d9d9',
                      animation: notRevisedExtras.length > 0 ? 'pulseGlow 2s infinite' : 'none',
                    }}>
                      <Icon type="eye-invisible" style={{ color: '#fff', fontSize: 10 }} />
                    </span>
                    Não revisados
                  </span>
                }
                value={notRevisedExtras.length}
                valueStyle={{ color: '#f5222d' }}
                valueRender={function(val) { return <small>{val}</small>; }}
              />
            </Card>
          </Col>
        </Row>

        <ExtrasTableList
          filteredData={activeExtras}
          statusFilters={applied.statusFilters}
          originFilters={applied.originFilters}
          isLoading={isLoading}
          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectedRowKeysChange,
          }}
          user={user}
          onAction={this.onAction}
          getFilename={this.getFilename}
        />

        <SelectionToolbar
          count={selectedRowKeys.length}
          onClear={this.handleClearSelection}
          itemLabel="serviço extra"
          actions={[
            { label: "Imprimir", icon: "printer", onClick: this.handleBulkPrint },
            { label: "Exportar", icon: "download", onClick: this.exportToExcel },
          ]}
        />
      </div>
      )
  }
}

const mapStateToProps = state => {
  return{
    user: state.user,
    extras: state.customerExtras.data,
    filter: state.customerExtras.filter,
    isLoading: state.customerExtras.isLoading,
    modalInactivate: state.customersnew.modalInactivate,
    findUser: (id) => state.users.filter(r=>r.id===id)[0],
  }
}

const mapDispatchProps = dispatch => {
  return{
    loadExtras: (filter) => dispatch(billsToReceiveActions.loadExtras(filter)),
    setPaid: (id) => dispatch({
      type: 'SET_PAID_EXTRA',
      payload: {
        request:{
          method: 'put',
          url:'/extras/payments/'+id,
        }
      },
      id: id
    }),
    changeStatus: (id, newStatus) => dispatch({
      type: '@@EXTRAS/STATUS',
      payload: {
        request:{
          method: 'put',
          url:'/extras/payments/'+id+'/status',
          data: {newStatus}
        }
      },
      id: id
    }),
    openBillForm: (data) => dispatch({
      type: 'OPEN_BILL_FORM',
      payload: data
    })
  }
}

export default connect(mapStateToProps, mapDispatchProps)(CustomersList);
